import React, { createContext, useContext, ReactNode } from "react";
import { KnowledgeItemWithPageContents, useKnowledgeItems } from "../hooks/useKnowledgeItems";

export interface IKnowledgeItemsContextType {
  knowledgeItems: KnowledgeItemWithPageContents[];
}

const defaultContext: IKnowledgeItemsContextType = {
  knowledgeItems: [],
};

export const KnowledgeItemsContext = createContext<IKnowledgeItemsContextType>(defaultContext);

export const KnowledgeItemsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const knowledgeItems = useKnowledgeItems();

  return <KnowledgeItemsContext.Provider value={{ knowledgeItems }}>{children}</KnowledgeItemsContext.Provider>;
};

export const useKnowledgeItemsContext = (): IKnowledgeItemsContextType => {
  const context = useContext(KnowledgeItemsContext);
  if (context === undefined) {
    throw new Error("useKnowledgeItemsContext must be used within a KnowledgeItemsProvider");
  }
  return context;
};
